import React, { FC } from 'react'
import { OrganizationAffiliation } from '@teschglobal/tg-fhir-react-components'
import FhirLoader from '../../../../FhirLoader'
import type { OrganizationAffiliation as FHIROrganizationAffiliation} from '@teschglobal/tg-fhir-react-components/dist/types'
import useFhirConfig from '../../../../../hooks/admin/useFhirConfig'

type OrganizationAffiliationDetailProps = {
    resource: FHIROrganizationAffiliation | null
    isFetching: boolean
}



const OrganizationAffiliationDetail: FC<OrganizationAffiliationDetailProps> = ({ resource, isFetching }) => {
    if (isFetching) return <FhirLoader />
    if (!resource) {
        return (
            <div className="text-center" role="status" aria-live="polite" aria-atomic="true">
                Not Found
            </div>
        )
    }
    const { providerDirectoryFhirConfig, handleSelectOrganization, handleSelectLocation } = useFhirConfig()
    return (
        <section>
            <OrganizationAffiliation
                data={resource}
                fhirApiConfig={providerDirectoryFhirConfig}
                onSelectOrganization={handleSelectOrganization}
                onSelectLocation={handleSelectLocation}
            />
        </section>
    )
}

export default OrganizationAffiliationDetail
